import React, { useState } from "react";

import { ImageInput, ImageField } from "react-admin";
import { Box, IconButton } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

const ImageItem = ({ sizesToRemove, label, source, src }) => {
  const [isDeleted, setIsDeleted] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const onDelete = () => {
    if (!sizesToRemove.includes(source)) sizesToRemove.push(source);
    setIsDeleted(true);
  };

  return (
    <div
      style={{
        borderRight: "0",
        borderLeft: "0",
        borderTop: "0",
        borderBottom: "1",
        borderColor: "black",
        borderStyle: "solid",
        width: "600px",
      }}
    >
      <ImageInput
        source={source}
        label={label}
        accept="image/*"
        options={{
          onDrop: onDelete,
        }}
      >
        <ImageField
          source="src"
          title="title"
        />
      </ImageInput>
      {src && !isDeleted && (
        <Box
          sx={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowDelete(true)}
          onMouseLeave={() => setShowDelete(false)}
        >
          <IconButton
            sx={{ position: "absolute", top: "8px", right: "8px", minWidth: "16px", opacity: showDelete ? 1 : 0 }}
            onClick={onDelete}
          >
            <RemoveCircleIcon sx={{ color: "#d32f2f" }} />
          </IconButton>
          <img
            src={src}
            alt={label}
            style={{ margin: "0.25rem", width: "200px", height: "100px", objectFit: "contain" }}
          />
        </Box>
      )}
    </div>
  );
};

export default ImageItem;
